import React, { useEffect, useState } from "react";

import Iframe from "react-iframe";

const InstagramCard = ({ item, styles }) => {
  const [coloumValue, setColoumValue] = useState(
    item?.coloum_value ? JSON.parse(item?.coloum_value) : null
  );

  const [iframeUrl, setIframeUrl] = useState(null);
  const [isGuide, setIsGuide] = useState(false);

  function transformInstagramGuideURL(url) {
    // Split the URL into parts using '/' as a delimiter
    const parts = url.split("/");

    // Check if the URL matches the expected pattern
    if (parts[4] === "guide") {
      // Replace the pattern with the desired format
      parts[5] = "_";

      // Join the parts back into a URL
      const transformedURL = parts.join("/");

      return transformedURL;
    }

    // If the URL doesn't match the expected pattern, return it as is
    return url;
  }
  useEffect(() => {
    if (item?.coloum_value) {
      setColoumValue(JSON.parse(item?.coloum_value));
    }
  }, [item]);

  useEffect(() => {
    var lastLetter =
      coloumValue?.coloum_value?.[coloumValue?.coloum_value?.length - 1];
    if (lastLetter === "/") {
      const newStr = coloumValue?.coloum_value?.slice(0, -1);

      if (newStr.includes("guide")) {
        setIsGuide(true);

        setIframeUrl(`${transformInstagramGuideURL(newStr)}/embed`);
      } else {
        setIsGuide(false);
        setIframeUrl(`${newStr}/embed/captioned`);
      }
    } else {
      const newStr = coloumValue?.coloum_value;

      if (newStr.includes("guide")) {
        setIsGuide(true);

        setIframeUrl(`${transformInstagramGuideURL(newStr)}/embed`);
      } else {
        setIsGuide(false);
        setIframeUrl(`${newStr}/embed/captioned`);
      }
    }
  }, [coloumValue]);

  return (
    <div className="w-full min-h-max">
      <Iframe
        id={iframeUrl}
        src={iframeUrl}
        width="100%"
        height={"100%"}
        className={`rounded-lg overflow-auto`}
        display="block"
        position="relative"
        frameBorder="0"
        scrolling="no" // Set scrolling attribute to "no"
        styles={{ minHeight: isGuide ? "320px" : "480px" }}
      />
    </div>
  );
};

export default InstagramCard;
